function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "35.005,116.281 43.759,103.79 43.759,97.514 46.228,97.514 65.021,75.035 73.802,66.272  70.056,62.518 76.278,56.312 73.802,47.531 76.278,37.509 82.511,31.276 88.743,35.031 91.255,31.276 91.255,25 97.522,22.54  97.522,16.246 102.485,3.746 108.78,0 108.78,10.04 106.294,16.246 108.78,28.764 115.083,25 123.747,28.764 123.747,35.031  126.269,47.531 126.269,62.518 126.269,66.272 153.755,87.544 158.78,128.764 164.995,137.535 164.995,141.299 156.259,147.522  162.526,165.048 162.526,168.768 123.747,200 102.485,193.785 99.999,190.039 76.278,187.49 65.021,183.753 58.78,181.276  52.565,171.262 54.954,168.768 54.954,147.522 50.054,150.088 37.517,131.285 "
});

var Svg09 = function Svg09(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CDMX",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg09, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/09.978b4066.svg";
export { ForwardRef as ReactComponent };